(function () {
	"use strict";

	document.addEventListener('DOMContentLoaded', function() {
		// Get all elements with the class 'js-toggle-handle'
		const toggleHandles = document.querySelectorAll(".js-toggle-handle");

		// Loop through each toggle handle
		toggleHandles.forEach(handle => {
			// Add click event listener to each handle
			handle.addEventListener("click", function() {
				// Find the sibling element with the class 'js-toggle-content'
				const content = this.nextElementSibling;
				if (content && content.classList.contains("js-toggle-content")) {
					// Toggle the 'hidden' class on the content element
					content.classList.toggle("hidden");
				}
			});
		});
	});

})();
